import { apiClient } from "@/shared/api/client";
import {
    GetStandardAreasResponseDto,
    SaveStandardAreaRequest,
    SupplierItemDto
} from '../types/standardArea.types';

const BASE_PATH = '/api/v1/standard-area';

export const standardAreaApi = {
    getStandardAreas: async (): Promise<GetStandardAreasResponseDto> => {
        const response = await apiClient.get<GetStandardAreasResponseDto>(BASE_PATH);
        return response.data;
    },

    getSupplierList: async (): Promise<SupplierItemDto[]> => {
        const response = await apiClient.get<SupplierItemDto[]>(`${BASE_PATH}/suppliers`);
        return response.data;
    },

    saveStandardArea: async (request: SaveStandardAreaRequest): Promise<void> => {
        await apiClient.post<void>(BASE_PATH, request);
    },

    deleteStandardArea: async (seqNo: number): Promise<void> => {
        await apiClient.delete<void>(`${BASE_PATH}/${seqNo}`);
    },

    autoRegister: async (userId: string): Promise<{ newAreaCount: number; newMappingCount: number }> => {
        const response = await apiClient.post<{ newAreaCount: number; newMappingCount: number }>(
            `${BASE_PATH}/auto-register`,
            { userId }
        );
        return response.data;
    },
};
